// Module
var code = "<!-- ko with: FunctionDesignerControl--> <div> <div data-bind=\"template: { name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data) }\"></div> </div> <!-- /ko -->";
// Exports
export default code;